// extracted by mini-css-extract-plugin
export default {"pinBlock":"PinBlock_pinBlock__u8tky","pin":"PinBlock_pin__GZb8U"};